import React from 'react'
import { View, Text, Icon } from '../primitives'

const Container = View.extend.attrs({
  className: 'o-layout__item'
})`
  position: relative;
  text-align: center;
  margin: auto;
  width: 100% !important;
`

const Relative = View.extend`
  position: relative;
`

const HR = View.extend`
  position: absolute;
  left: 0;
  right: 0;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.borderColor};
  top: 50%;
  z-index: -1;
`

const Button = Text.extend.attrs({
  py: 2,
  px: 4,
  fontSize: 2,
  color: 'primary2Color',
  fontWeight: 'bold'
})`
  position: relative;
  display: inline-flex;
  align-items: center;
  border: 1px solid ${({ theme: { colors } }) => colors.borderColor};
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ theme: { colors } }) => colors.canvasColor};
  cursor: pointer;
  &:hover > * {
    opacity: 0.8;
  }
`

const ChevronDown = Icon.extend.attrs({
  icon: 'keyboard-arrow-down',
  size: 20,
  color: 'alternateTextColor'
})`
position: relative;
top: 2px;
left: 4px;
`

export default ({ translations, size, onClick }) => (
  <Container>
    <Relative>
      <HR />
      <Button onClick={onClick}>
        <Text>
          {translations['loadMore'] &&
            translations['loadMore'].replace('{X}', size)}
        </Text>
        <ChevronDown />
      </Button>
    </Relative>
  </Container>
)
